module.exports = __webpack_public_path__ + "img/pencil_blue.50f39217.svg";